export const FRONT_PATH_APPS = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  FRONT_ELECTRONIC_SIGNATURE: 'front-electronic-signature'
};
